import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import Config from '../../../constants/appConfig';
import MaterialIcon from '../../../components/MaterialIcon';
import { notification } from 'antd';

import { useParams } from "react-router";

import Input from '@material-ui/core/Input';
import MaskedInput from 'react-text-mask';

import Tools from '../../../components/util/tools';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  }
});

class Edit extends React.Component {
  state = {
    cpfError: false,
    phoneError: false,
    id: this.props.id,
    name: '',
    cpf: '',
    email: '',
    phone: '',
    canac: '',
    birthdate: null,
    mnte_validate: null,
    paga_validate: null,
    cma_validate: null,
    guid: null,
  };

  componentDidMount() {
    if (this.state.id) {
      const apiUrl = Config.server + '/pilot/' + this.state.id;

      const options = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.json();
        })
        .then(
          (result) => {
            if (result.length > 0) {
              this.setState({
                name: result[0].name,
                cpf: result[0].cpf,
                email: result[0].email,
                phone: result[0].phone || '',
                canac: result[0].canac,
                birthdate: result[0].birthdate ? Tools.getDateToInputDate(result[0].birthdate) : null,
                mnte_validate: result[0].mnte_validate ? Tools.getDateToInputDate(result[0].mnte_validate) : null,
                paga_validate: result[0].paga_validate ? Tools.getDateToInputDate(result[0].paga_validate) : null,
                cma_validate: result[0].cma_validate ? Tools.getDateToInputDate(result[0].cma_validate) : null,
                guid: result[0].guid
              });
            }
          },
          (error) => {
            if (error.status === 401) {
              this.props.link('/login');
            }
            else {
              console.log(error);
              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    }
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  };

  maskedCPF = (props) => {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  };

  normalizePhone = (value) => {
    if (!value) return '';

    let normalized = value.replace(/[^\d+\-() ]/g, '');
    normalized = normalized.replace(/\+/g, function (match, offset) {
      return offset === 0 ? '+' : '';
    });

    return normalized;
  };

  isValidPhone = (phone) => {
    if (!phone || !phone.trim()) return true;
    if (!/^\+?[\d\s\-()]+$/.test(phone)) return false;

    const digits = phone.replace(/\D/g, '');

    if (digits.length < 10 || digits.length > 15) return false;

    return true;
  };

  handleChange = name => event => {
    let value = event.target.value;

    if (name === 'phone') {
      value = this.normalizePhone(value);
    }

    this.setState({
      [name]: value,
    });
  };

  handleAircraftBrandChange = event => {
    this.setState({
      id_aircraftbrand: event.target.value,
      id_aircraftmodel: ''
    });
    if (event.target.value) {
      this.loadAircraftModels(event.target.value);
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.state.cpfError || isNaN(this.state.cpf.replace('.', '').replace('-', '')) || !this.state.cpf) {
      notification.open({
        message: this.props.res.CPF_INVALIDO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      this.setState({ cpfError: true });
      return;
    }

    if (!this.isValidPhone(this.state.phone)) {
      notification.open({
        message: this.props.res.TELEFONE_INVALIDO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      this.setState({ phoneError: true });
      return;
    }

    let apiUrl = '';
    let method = '';
    apiUrl = Config.server + '/pilot/';

    const formData = new URLSearchParams();
    if (this.state.id) {
      apiUrl += this.state.id;
      formData.append('pilot_id', this.state.id);
      method = 'PUT';
    } else {
      method = 'POST';
    }

    formData.append('pilot_cpf', this.state.cpf);
    formData.append('pilot_name', this.state.name);
    formData.append('pilot_email', this.state.email);
    formData.append('pilot_phone', this.state.phone);
    formData.append('pilot_canac', this.state.canac);
    formData.append('pilot_birthdate', this.state.birthdate);
    formData.append('pilot_mnte_validate', this.state.mnte_validate);
    formData.append('pilot_paga_validate', this.state.paga_validate);
    formData.append('pilot_cma_validate', this.state.cma_validate);
    formData.append('pilot_guid', this.state.guid);

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result && result.error) {
            notification.open({
              message: this.props.res[result.message],
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else {
            let msg = this.props.res.ITEM_INCLUIR;
            if (this.state.id) {
              msg = this.props.res.ITEM_ALTERADO;
            }
            notification.open({
              message: this.props.res.SUCESSO,
              description: msg,
              icon: <MaterialIcon icon="check_circle" className="text-success" />
            });

            if (!this.state.id) {
              this.setState({
                name: '',
                cpf: '',
                email: '',
                phone: '',
                canac: '',
                birthdate: null,
                mnte_validate: null,
                paga_validate: null,
                cma_validate: null,
                guid: null,
                phoneError: false
              });
            }
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  render() {
    const { link, res } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="containerTop">
          <div><h1>{res.PILOTO}</h1></div>
          <div className="centerTop"></div>
          <div>
            <Button variant="contained" onClick={evemt => { link('/app/cadastro/piloto/list') }} className="popUpButton">
              {res.CANCELAR}
            </Button> &nbsp;
            <Button type="submit" variant="contained" color="primary" className="popUpButton">
              <SaveIcon className="iconMapS" />
              {res.SALVAR}
            </Button>
          </div>
        </div>
        <div className="form-group notTooBig">
          <TextField
            id="name"
            label={res.NOME}
            value={this.state.name}
            required={true}
            onChange={this.handleChange('name')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <FormControl
            fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">{res.CPF + ' *'}</InputLabel>
            <Input
              value={this.state.cpf || ' '}
              error={this.state.cpfError}
              onChange={(ev) => {
                this.setState({ cpfError: isNaN(this.state.cpf.replace('.', '').replace('-', '')) })
                this.handleChange('cpf')(ev);
              }}
              name="textmask"
              id="formatted-text-mask-input"
              inputComponent={this.maskedCPF}
            />
          </FormControl>
          <TextField
            id="email"
            label={res.EMAIL}
            required={true}
            value={this.state.email}
            onChange={this.handleChange('email')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="phone"
            label={res.TELEFONE}
            value={this.state.phone}
            error={this.state.phoneError}
            onChange={(ev) => {
              this.handleChange('phone')(ev);
              this.setState({ phoneError: false });
            }}
            onBlur={() => {
              this.setState({ phoneError: !this.isValidPhone(this.state.phone) });
            }}
            margin="normal"
            fullWidth
            inputProps={{
              inputMode: 'tel',
              maxLength: 25
            }}
            helperText={this.state.phoneError ? res.INFORMAR_TELEFONE_VALIDO : ''}
          />
          <TextField
            id="canac"
            label={res.CANAC}
            value={this.state.canac}
            required={true}
            onChange={this.handleChange('canac')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <FormControl style={{ width: '100%', marginTop: '1rem' }}>
            <TextField
              id="birthdate"
              type="date"
              label={res.DATANASCIMENTO}
              value={this.state.birthdate}
              onChange={this.handleChange('birthdate')}
              style={{ width: '11rem', marginBottom: '1rem' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="mnte_validate"
              type="date"
              label={res.MNTEVALIDATE}
              value={this.state.mnte_validate}
              onChange={this.handleChange('mnte_validate')}
              style={{ width: '11rem', marginBottom: '1rem' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="paga_validate"
              type="date"
              label={res.PAGAVALIDATE}
              value={this.state.paga_validate}
              onChange={this.handleChange('paga_validate')}
              style={{ width: '11rem', marginBottom: '1rem' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="cma_validate"
              type="date"
              label={res.CMAVALIDATE}
              value={this.state.cma_validate}
              onChange={this.handleChange('cma_validate')}
              style={{ width: '11rem', marginBottom: '1rem' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl>
        </div>
      </form>
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res } = props;
  let { id } = useParams();
  return (
    <div className="rowForm">
      <div className="divContent">
        <TextFields1 link={link} id={id} res={res} />
      </div>
    </div>)
}

export default Box;